import "./tabsStyles.css";
import { Col, Row, Container } from "react-bootstrap";
import { useEffect, useState } from "react";
import Moment from "react-moment";

export default function DailyTab({ data }: any) {
  const [ok, setOk] = useState(false);

  useEffect(() => {
    if (data !== undefined || data !== null) {
      setOk(true);
    }
  }, [data]);

  const convertTimeStamp = (unixTimestamp: number) => {
    let time = new Date(unixTimestamp * 1000).toLocaleTimeString("en-US");
    return time;
  };

  return (
    <div className="make-visible">
      <h2>Daily Forecast</h2>
      {ok ? (
        <div>
          {data.daily.map((item: any, index: number) => {
            let icon_path = `http://openweathermap.org/img/w/${item.weather[0].icon}.png`;
            return (
              <Container className="clean-box" key={`daily-${index}`}>
                <Row>
                  <Col xs={3}>
                    {" "}
                    <img className="minor-icons" src={icon_path} />{" "}
                  </Col>
                  {/* <Col>Time : </Col>  */}
                  <Col>
                    {" "}
                    <Moment unix>{item.dt}</Moment>{" "}
                  </Col>
                  {/* <Col >{item.summary} and there is {Math.round(item.precipProbability)*100}% chance of rain.</Col> <Col xs={8}></Col> */}
                </Row>
                <Row xs={2} md={4}>
                  <Col>Max : </Col> <Col> {item.temp.max} °C</Col>
                  <Col>Min : </Col> <Col> {item.temp.min} °C </Col>
                  <Col>Sunrise : </Col>{" "}
                  <Col> {convertTimeStamp(item.sunrise)} </Col>
                  <Col>Sunset : </Col>{" "}
                  <Col> {convertTimeStamp(item.sunset)} </Col>
                  <Col>Pressure : </Col> <Col> {item.pressure} mb </Col>
                  <Col>Wind : </Col> <Col> {item.wind_speed} m/sec </Col>
                  <Col xs={7}>Wind Direction : </Col>{" "}
                  <Col xs={1}> {item.wind_deg}° </Col>
                  <Col>Humidity : </Col>{" "}
                  <Col> {Math.round(item.humidity * 100)}% </Col>
                  <Col>UV Index : </Col> <Col> {item.uvi} out of 10 </Col>
                  <Col>Clouds : </Col>{" "}
                  <Col> {Math.round(item.clouds * 100)}% </Col>
                  <Col>Moon Phase : </Col> <Col> {item.moon_phase * 100}% </Col>
                  <Col>Dew Point : </Col> <Col> {item.dew_point} °C </Col>
                </Row>
              </Container>
            );
          })}
        </div>
      ) : (
        <div>Loding...</div>
      )}
    </div>
  );
}
